import React from 'react';
import { SxProps } from '@mui/material';
import RecentHiringActivityGroupedList from './recentHiringActivityGroupedList';
import 'modules/hiring/components/candidatesAwaitingReview/candidatesAwaitingReview.scss';
import { mapRecentHiringActivityDataToCardData } from 'modules/hiring/models/recentHiringActivity.model';
import { useRecentHiringActivity } from 'modules/hiring/hooks/useRecentHiringActivity';
import RecentHiringActivityShimmer from './recentHiringActivityShimmer';

interface IRecentHiringActivityContentWrapper {
  recentDaysLimit: number;
  recentHiringActivitySxProps?: SxProps;
}

const RecentHiringActivityContentWrapper = (
  props: IRecentHiringActivityContentWrapper
) => {
  const { recentDaysLimit, recentHiringActivitySxProps } = props;
  const { recentHiringActivity, loading } = useRecentHiringActivity();

  return (
    <>
      {loading ? (
        <RecentHiringActivityShimmer />
      ) : (
        <RecentHiringActivityGroupedList
          id='recent-hiring-activities'
          className='innerContainer'
          sx={{
            maxHeight: 350,
            overflowY: 'auto',
            pr: ({ typography }) => typography.pxToRem(8),
            mr: ({ typography }) => typography.pxToRem(-16),
            pt: ({ typography }) => typography.pxToRem(8),
            ...recentHiringActivitySxProps,
          }}
          data={mapRecentHiringActivityDataToCardData(
            recentHiringActivity,
            recentDaysLimit
          )}
          recentDaysLimit={recentDaysLimit}
          endOfListI18Key='reachedEndOfWeek'
        />
      )}
    </>
  );
};

export default RecentHiringActivityContentWrapper;
